import { useLiveQuery } from 'dexie-react-hooks';

import { db } from 'technical/db';
import { formatBoardSegments } from 'ui/quality-control/board/utils';

export const useBoardData = () => {
  return useLiveQuery(async () => {
    const [
      segmentDrawConfigs,
      tunnelPositions,
      rings,
      defectReports,
      defectReportTypes,
      repairReports,
    ] = await Promise.all([
      db.segmentDrawConfigs.orderBy('order').toArray(),
      db.tunnelPositions.orderBy('keyPosition').toArray(),
      db.rings.orderBy('ringNumber').reverse().toArray(),
      db.defectReports.orderBy('ringId').toArray(),
      db.defectReportTypes.toArray(),
      db.repairReports.toArray(),
    ]);

    const ids = rings.map((ring) => ring.ringNumber);

    const formattedRings = formatBoardSegments(
      segmentDrawConfigs,
      tunnelPositions,
      rings,
      defectReports,
      defectReportTypes,
      repairReports,
    );

    return {
      ringInterval: {
        start: Math.min(...ids),
        end: Math.max(...ids),
      },
      rings: formattedRings,
      segmentDrawConfigs,
    };
  }, []);
};
